function getDataAttributes(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => key.startsWith('data-')));
}
function splitElementAttributes(obj) {
    const { dataAttributes, elementAttributes } = Object.entries(obj).reduce((acc, [key, value]) => {
        if (key.startsWith('data-')) {
            acc.dataAttributes[key] = value;
        }
        else {
            acc.elementAttributes[key] = value;
        }
        return acc;
    }, { dataAttributes: {}, elementAttributes: {} });
    return { dataAttributes, elementAttributes };
}

export { getDataAttributes as g, splitElementAttributes as s };

//# sourceMappingURL=data-attributes.js.map